import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useReturnUrl = () : string => {
  const [returnUrl, setReturnUrl] = useState('');
  const { search } = useLocation();
  useEffect(() => {
    const queryString = new URLSearchParams(search);
    const urlParam = queryString.get('returnUrl') || Cookies.get('returnUrl');
    if (typeof urlParam === 'string') {
      setReturnUrl(typeof urlParam === 'string' ? decodeURIComponent(urlParam || '') : '');
      Cookies.set('returnUrl', urlParam);
    }
  });
  return returnUrl;
};

export default useReturnUrl;